'LocationList'.list({expose: true, icon: 'Cubes'})
'Locations'.title()
'Back'.action({act: 'cancel'})
'Add'.action({act: 'add'})
'Location'.datatype()
'locationName'.field({caption: "Name"})
'Edit'.action({place: 'row', act: 'edit'})
'Inventory'.action({place: 'row', spec: "LocationInventoryList.js"})
'Trash'.action({place: 'row', act: 'trash'})
'LocationMaint.js'.maintSpecname()
